export const TABLES_KEYS = Object.freeze({
  aiProspectingAssistantResults: 'ai-prospecting-assistant-results'
});
